import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {useToggle} from 'react-use';

import DropdownMenu from '../../dropdown/DropdownMenu';
import CardCircle from './CardCircle';
import CardGrid from './CardGrid';
import ClickOutside from '../../ClickOutside';

import styles from './card-grid.module.css';
export const GRID = 'grid';
export const CIRCLE = 'circle';

function CardChart(props) {
    const {title, description, data, type, onChangeAction, onUpdateNote, onUpdateTitle, hideOptions, yearOptions} = props;
    const [on, toggle] = useToggle(false);
    const [titleRaw, setTitleRaw] = useState('');
    const [note, setNote] = useState('');
    const [downloadCSV, setDownloadCSV] = useState(false);
    const [yearId, setYearId] = useState((yearOptions && yearOptions.list.length > 0) ? yearOptions.list[0].year_id : null);

    useEffect(() => {
        setNote(description);
    }, [description]);

    useEffect(() => {
        setTitleRaw(title);
    }, [title]);

    return <div className={styles.cardGridWrapper}>
        <div className={styles.titleWrapper}>
            <h3 className={styles.title}>
                <input type="text"
                       value={titleRaw}
                       className={styles.input}
                       onBlur={() => onUpdateTitle(titleRaw)}
                       onChange={(e) => setTitleRaw(e.target.value)}
                />
            </h3>
            {
                yearOptions && <div>
                    <select className="form-control" value={yearId}
                            onChange={(e) => {
                                setYearId(e.target.value)
                                yearOptions.getData(yearOptions.player_id, e.target.value);
                            }}>
                        {
                            yearOptions.list.map((val, i) => {
                                return <option key={i} value={val.year_id}>{val.year}</option>
                            })
                        }
                    </select>
                </div>
            }
            {!hideOptions && <div className={styles.titleRightWrapper}>
                <div style={{position: 'relative'}}>
                    <ClickOutside onClickOutside={() => toggle(false)}>
                        <button className={classNames(styles.buttonChart)}
                                style={{
                                    paddingLeft: 15,
                                    display: 'flex',
                                    alignItems: 'center',
                                }} onClick={toggle}>
                            <img src={description ? '/img/ic_comment_bold.svg' : '/img/ic_comment_light.svg'} alt=""/>
                        </button>
                        {on && <div className={styles.inputWrapper}>
                            <textarea value={note || ''}
                                      onBlur={() => onUpdateNote(note)}
                                      className={styles.inputWrapperTextarea}
                                      onChange={(e) => setNote(e.target.value)}
                                      rows="4"
                                      placeholder={'メモ'}
                            />
                        </div>}
                    </ClickOutside>
                </div>
                <DropdownMenu position={'right'}
                              list={[
                                  {name: 'CSVダウンロード', value: 'csv'},
                                  {name: '削除', value: 'remove'}
                              ]}
                              getOptionLabel={(option) => option.name}
                              onChange={(item) => {
                                  if(item.value === 'csv') {
                                      setDownloadCSV(true);
                                      setTimeout(() => {
                                          setDownloadCSV(false);
                                      }, 1000);
                                      return;
                                  }
                                  onChangeAction(item, type);
                              }}>
                    <img style={{paddingLeft: 7, paddingRight: 7}} src="/img/more_vert_24px.png" className={'more-button-action'} alt="more"/>
                </DropdownMenu>
            </div>}
        </div>
        <div style={{padding: 15, height: 350}}>
            {type === GRID && <CardGrid
                title={title}
                description={description}
                data={data}
                downloadCSV={downloadCSV}/>}
            {type === CIRCLE && <CardCircle
                title={titleRaw}
                description={description}
                data={data}
                downloadCSV={downloadCSV}/>}
        </div>
        {description && <p className={styles.description}>
            {description}
        </p>}
    </div>
}

CardChart.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    data: PropTypes.object.isRequired,
    type: PropTypes.string,
    onChangeAction: PropTypes.func,
    onUpdateNote: PropTypes.func,
    hideOptions: PropTypes.bool,
    yearOptions: PropTypes.object,
};

CardChart.defaultProps = {
    title: '',
    description: '',
    type: GRID,
    data: {},
    hideOptions: false,
    yearOptions: null,
};

export default CardChart;
